import { Avatar, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import { T } from "../../util/t";
import { Close, Person, People, ChevronRight } from "@mui/icons-material";
import { useTakeoverDialogStyles } from "../forms/SearchTakeoverDialog";
import { VisualListButton } from "./AthleteSummary";
import { makeStyles } from "../../providers/makeStyles";
import { useListStyles } from "./SelectAthleteDialog";
import { useState } from "react";
import { DIALOGS } from "./EntrySelector";

const useStyles = makeStyles(theme => ({
    individual: {
        backgroundColor: theme.palette.tertiary.lighter
    },
    team: {
        backgroundColor: theme.palette.background.high
    }
}));
export const EntryTypeDialog = ({ closeDialog, dialogId, ...rest }) => {
    const [entryType, setEntryType] = useState();

    if (!entryType) return <EntryTypeDialogContent dialogId={dialogId} closeDialog={closeDialog} setEntryType={setEntryType} />;

    const Dialog = DIALOGS[entryType];

    return <Dialog dialogId={`${entryType}-selector-dialog-title`} closeDialog={closeDialog} {...rest} />;
};

const EntryTypeDialogContent = ({ dialogId, closeDialog, setEntryType }) => {
    const listClasses = useListStyles();
    const classes = useTakeoverDialogStyles();
    const dialogClasses = useStyles();

    return (
        <>
            <DialogTitle id={dialogId}>
                <Typography variant="h3" component="div" className={classes.title}>
                    <T>Enter an individual or team?</T>
                    <IconButton color="inherit" size="small" onClick={closeDialog}><Close/></IconButton>
                </Typography>
            </DialogTitle>

            <DialogContent className={classes.dialogContent}>
                <ul className={listClasses.list}>
                    <li>
                        <VisualListButton
                            icon={<Avatar className={dialogClasses.individual}><Person /></Avatar>}
                            text={<T>Individual</T>}
                            onClick={() => setEntryType("individual")}
                            aside={<ChevronRight/>}
                        />
                    </li>
                    <li>
                        <VisualListButton
                            icon={<Avatar className={dialogClasses.team}><People /></Avatar>}
                            text={<T>Team</T>}
                            onClick={() => setEntryType("team")}
                            aside={<ChevronRight/>}
                        />
                    </li>
                </ul>
            </DialogContent>
        </>
    );
};
